import {
  memo, ReactElement, useCallback,
} from 'react';
import cn from 'classnames';
import { createUseStyles } from 'react-jss';

const defaultProps = {
  hasError: false,
};

type TextInputProps = {
  label?: string,
  placeholder?: string
  value?: string,
  className?: string,
  onChange?: (value: string) => void,
  hasError?: boolean,
  errorText?: string,
  disabled?: boolean,
} & typeof defaultProps;

const TextInput = (props: TextInputProps): ReactElement => {
  const {
    label, placeholder, value, onChange, className, hasError, errorText, disabled,
  } = props;

  const classes = useClasses();

  const handleChange = useCallback((event: any) => {
    onChange?.(event.target.value);
  }, [onChange]);

  return (
    <div className={cn(className, classes.textInput)}>
      {label && (
        <div className={classes.label}>{label}</div>
      )}
      <input
        placeholder={placeholder}
        className={cn(classes.input, { [classes.inputError]: hasError })}
        value={value}
        disabled={disabled}
        onChange={handleChange}
      />
      <div className={cn(classes.errorText, { [classes.visibility]: hasError })}>{errorText}</div>
    </div>
  );
};

TextInput.defaultProps = defaultProps;

const useClasses = createUseStyles({
  textInput: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    color: '#454545',
  },
  label: {
    fontWeight: 500,
    fontSize: '1.5rem',
    color: '#3F3F3F',
    marginBottom: '0.8rem',
  },
  input: {
    fontFamily: 'Avenir Next, sans-serif',
    fontWeight: 500,
    fontSize: '1.5rem',
    borderRadius: '0.7rem',
    boxShadow: '1px 2px 5px rgba(0, 0, 0, 0.05)',
    border: '1px solid #ffffff',
    background: '#ffffff',
    padding: '1.1rem 1.5rem',
    color: '#3F3F3F',
  },
  inputError: {
    border: '1px solid red',
  },
  errorText: {
    visibility: 'hidden',
    marginTop: '0.6rem',
    fontSize: '1.1rem',
    color: 'red',
    textAlign: 'right',
  },
  visibility: {
    visibility: 'visible',
  },
});

export default memo(TextInput);
